<template>
  <transition name="scroll">
    <div id="page">
      <div class="page-status" v-if="$store.getters.isMember" :class="{publish: page.publish}">
        <p>{{ $store.getters.pageStatus }}</p>
      </div>
      <header>
        <div>
          <figure class="image" v-for="image in [page.images[0]]"
            :id="pageImages[0].id" :key="image.id">
            <cachalog-img :type="'background'" :class="pageImages[0].class[1]" :caption="image.caption"
              :full-path="image.full_path" :source="image.source"></cachalog-img>
          </figure>
        </div>
        <div class="detail">
          <figure class="image" v-for="image in [page.images[1]]"
            :id="pageImages[1].id" :key="image.id">
            <cachalog-img :type="'background'" :class="pageImages[1].class[1]" :caption="image.caption"
              :full-path="image.full_path" :source="image.source"></cachalog-img>
          </figure>
          <div>
            <h1 class="is-cs-2 title">{{ page.title }}</h1>
            <!--<div class="is-cs-6">
              <span v-if="dates[0]"><time class="is-cs-4">{{ dates[0] }}</time> から</span>
              <span v-if="dates[1]"><time class="is-cs-4">{{ dates[1] }}</time> まで</span>
            </div>-->
            <div class="is-cs-5">
              <a class="is-c-text" target="_blank" rel=”noopener”
               v-for="link in page.links" :href="link.url" :key="link.url">{{ link.url }}</a>
            </div>
            <div class="buttons level is-mobile" v-if="$store.getters.isMember">
              <div class="edit-page">
                <router-link class="button" :to="{name: 'page-editor'}">
                  <span class="is-cs-4 is-c-text has-text-weight-bold">ショップ編集</span>
                </router-link>
              </div>
              <div class="show-qrcode">
                <router-link class="button level" :to="{name: 'qrcode-page'}">
                  <i></i>
                  <span class="is-cs-4 is-c-text has-text-weight-bold">ショップQR</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="description">
          <p>{{ page.description }}</p>
        </div>
        <div class="boot-qrcode-reader has-text-centered" v-if="$store.getters.isMember">
          <router-link :to="{name: 'qrcode-reader'}">
            <button class="button is-rounded is-c-primary is-cs-4 is-large">
              注文読み込み
              <span class="icon">
                <i class="fas fa-2x fa-qrcode"></i>
              </span>
            </button>
          </router-link>
        </div>
      </header>
      <div class="tabs is-centered is-cs-4">
        <!--<ul>
          <li class="is-active"><a>商品</a></li>
          <li><a>フィード</a></li>
        </ul>-->
      </div>
      <div class="item-list-tile">
        <cachalog-item-list v-for="(item, index) in page.items"
          :item="item" :index="index" :parent="'page'" :wishlist="wishlist"
          :class="{'sold-out': item.sold_out}" :key="index"></cachalog-item-list>
        <div class="add-item-button" v-if="$store.getters.isMember">
          <router-link class="is-c-primary" :to="{name: 'item-editor', params: {itemId: 'new'}}">
            <i class="c-icon"></i>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Vuex from 'vuex'
import { mixin, datestr } from './common.js'
export default {
  mixins: [mixin],
  props: ['pageId'],
  computed: {
    ...Vuex.mapState({
      user: 'user',
      page: 'page',
      pageImages: 'pageImages',
      wishlist: 'wishlist'
    }),
    pageTitle () {
      return this.page.title || ''
    },
    dates () {
      const dates = []
      for (let i = 0; i < 2; i++) {
        let date = this.page.dates ? this.page.dates[i] : null
        if (date && date.date.seconds) {
          dates[i] = datestr(date.date.toDate(), 'Y/m/d')
        } else if (date && date.date) {
          dates[i] = datestr(date.date, 'Y/m/d')
        } else {
          dates[i] = null
        }
      }
      return dates
    }
  },
  created () {
    this.$store.commit('changePageMainComponent', 'page')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page.vue